import {AddTelegramAccountFormField} from "../types/add-telegram-account-form.types";
import {Validators} from "@angular/forms";

export const addTelegramAccountFormFields: Array<AddTelegramAccountFormField> = [
  {
    fieldName: "accountId",
    label: 'Аккаунт Id',
    validators: [ Validators.required ],
    stepVisible: [ 0, 2 ],
    type: 'text'
  },
  {
    fieldName: "phone",
    label: 'Номер телефона',
    validators: [ Validators.required ],
    stepVisible: [ 0, 2 ],
    type: 'text'
  },
  {
    fieldName: "apiId",
    label: 'ApiId',
    validators: [ Validators.required ],
    stepVisible: [ 0, 2 ],
    type: 'number'
  },
  {
    fieldName: "apiHash",
    label: 'ApiHash',
    validators: [ Validators.required ],
    stepVisible: [ 0, 2 ],
    type: 'text'
  },
  {
    fieldName: "name",
    label: 'Имя',
    stepVisible: [ 0, 2 ],
    type: 'text'
  },
  {
    fieldName: "link",
    label: 'Ссылка',
    stepVisible: [ 0, 2 ],
    type: 'text'
  },
  {
    fieldName: "email",
    label: 'Email',
    stepVisible: [ 0, 2 ],
    type: 'text'
  },
  {
    fieldName: "password",
    label: 'Пароль',
    stepVisible: [ 0, 2 ],
    type: 'text'
  }
]

export const addTelegramAccountCodeFormFields: Array<AddTelegramAccountFormField> = [
  {
    fieldName: "accountId",
    label: 'Аккаунт Id',
    validators: [ Validators.required ],
    stepVisible: [ 1 ],
    disabled: true,
    type: 'text'
  },
  {
    fieldName: "code",
    label: 'Код',
    validators: [ Validators.required ],
    stepVisible: [ 1 ],
    type: 'text'
  }
]
